module.exports = __webpack_public_path__ + "img/jifenrenwu_wanshanxinxiyouli.1f706d61.png";